<template>
  <div class="create-room">
    <div class="card">
      <div class="card-header">
        ルーム作成
      </div>
      <div class="card-body">
        <div class="form-group">
          <label for="name">ルーム名</label>
          <input class="form-control" type="text" id="name" v-model="room.name">
        </div>
        <!-- <div class="form-group">
          <label for="n_members">人数</label>
          <input class="form-control" type="number" id="n_members" v-model="room.n_members">
        </div> -->
        <div class="form-group">
          <label for="password">パスワード</label>
          <input class="form-control" type="password" id="password" v-model="room.password">
        </div>
        <div class="alert alert-info">
          作成されたルームは1日経過すると削除されます。
        </div>
        <button type="button" name="button" class="btn btn-danger" @click="createRoom">作成</button>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'create-room',
  components: {

  },
  data() {
    return {
      room: {
        name: '',
        password: '',
        owner: null,
        members: [],
        stateIndex: 0,
        created: null,
        votes: [],
        isDecidedTheme: {}
      }
    }
  },
  methods: {
    createRoom(){
      const vue = this;
      firebase.auth().onAuthStateChanged((user)=>{
        if (user) {
          // ログイン中
          this.room.owner = user.uid;
          this.room.members.push({uid: user.uid, name: user.displayName});
          this.room.created = firebase.firestore.FieldValue.serverTimestamp();

          const db = firebase.firestore();
          db.collection('rooms').add(this.room).then((doc)=>{
            vue.$router.push('/rooms/game/'+doc.id);
          });
        }
      });
    }
  }
}
</script>
<style scoped>
</style>
